/** Timesheet sheet tab — pick an employee and a pay period; the sheet is laid out like the Excel timesheets. */
import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { PersonPicker } from './EmployeeMonthTab';
import TimesheetSheet from './TimesheetSheet';
import { api, errorText, thisMonth } from './shared';

export default function SheetTab({ token, isRTL, employeeId, month, onSelect }) {
  const t = (en, ar) => (isRTL ? ar : en);
  const key = month || thisMonth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!employeeId) { setData(null); return; }
    setLoading(true); setError('');
    try { setData(await api(token).get(`/sheets/${employeeId}/${key}`)); } catch (e) { setError(errorText(e)); setData(null); }
    finally { setLoading(false); }
  }, [token, employeeId, key]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4 mt-4" data-testid="attendance-sheet">
      <div className="flex flex-wrap items-center gap-2 no-print">
        <PersonPicker token={token} isRTL={isRTL} value={employeeId} onChange={(id) => onSelect(id, key)} />
        <label className="text-sm text-slate-500">{t('Pay period ending in', 'فترة الراتب المنتهية في')}</label>
        <Input type="month" value={key} onChange={(e) => onSelect(employeeId, e.target.value)} className="w-40" data-testid="sheet-month" />
        <Button variant="outline" size="sm" onClick={load} disabled={loading || !employeeId}>
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
        </Button>
      </div>
      {error && <div className="text-sm text-rose-600">{error}</div>}
      {!employeeId && <div className="brand-empty-state p-8 text-center text-slate-500">{t('Choose an employee.', 'اختر موظفاً.')}</div>}
      {data && <TimesheetSheet token={token} isRTL={isRTL} data={data} exportPath={`/sheets/${employeeId}/${key}/xlsx`} />}
    </div>
  );
}
